import { DataService } from '../dataService';
import { aimController } from './controllers/AIMController';
import { Capabilities } from './models/AIMModels';
import { AIM_SERVICE, INFOR_ENV } from './envUtils';

const Index = () => {
  const service = new DataService(`${AIM_SERVICE}`);
  const inforAuth = async () => {
    return new Promise((resolve, reject) => {
      try {
        let expired = true;
        const cachedAuth = localStorage.getItem('infor-auth');
        if (cachedAuth) {
          const result = JSON.parse(cachedAuth);
          expired = result.expires <= Date.now();
          if (!expired) resolve(result);
        }
        if (expired) {
          service.get({ route: [`authorization/status/${INFOR_ENV}`] }).then(({ data }: any) => {
            const auth = data.authorization_granted;
            if (!auth) {
              window.location.replace(
                `${AIM_SERVICE}/authorization/authorize/${INFOR_ENV}?redirect=${window.location.href}`
              );
            } else {
              data.expires = Date.now() + 60000 * 60; // cached for an hour
              localStorage.setItem('infor-auth', JSON.stringify(data));
              resolve(data);
            }
          });
        }
      } catch (e) {
        localStorage.removeItem('infor-auth');
        reject(e);
      }
    });
  };
  const getAccess = async (): Promise<Capabilities> => {
    let expired = true;
    const cachedAuth = localStorage.getItem('aim-capabilities');
    if (cachedAuth) {
      const result = JSON.parse(cachedAuth);
      expired = result.expires <= Date.now();
      if (!expired) {
        return result;
      }
    }
    const { data } = await service.get({ route: [INFOR_ENV, 'capabilities'] });
    data.expires = Date.now() + 60000 * 60 * 24;
    localStorage.setItem('aim-capabilities', JSON.stringify(data));
    return data;
  };
  const revokeInforAuth = () => {
    service.get({ route: [`authorization/revoke/${INFOR_ENV}`] }).then(() => {
      console.log('revoked');
    });
  };
  const revokeInforAuthAsync = async () => {
    await service.get({ route: [`authorization/revoke/${INFOR_ENV}`] });
  };

  return {
    getAccess,
    inforAuth,
    revokeInforAuth,
    revokeInforAuthAsync,
    service: service,
    aim: aimController(service)
  };
};

/**
 * MSAL scope configuration for the AIM API, defining the single-user-impersonation scope used for authentication.
 */
export const aimScopes = {
  scopes: ['api://1cea8ce4-5aa3-4d88-b63f-2bd344ea6d25/user_impersonation']
};
/**
 * Instantiated AIM API service object with `getAccess` and `inforAuth` authentication helpers, along with access to the DataService instance and the structured AIM controller (aim).
 */
export const AimApi = Index();

export * from './models/APIModels';
export * from './models/AIMModels';
export * from './models/EmailNotificationModels';
export * from './models/TransactionTeamModels';
//@ts-ignore
export * from './models/PrismTransactionModels';
export * from './models/MarketValue';
export * from './models/ApprovalModels';
export * from './models/AttachmentModels';
//@ts-ignore
export * from './models/OpportunityModels';
export * from './models/ChipsHarvestYield';
export * from './models/JarvisOnbaseDocument';
export * from './models/OnBaseDocumentType';
export * from './controllers/hooksServices/LookupsHooksService';
export * from './controllers/hooksServices/OpportunityHooksService';
export * from './controllers/hooksServices/TransactionTeamHooksService';
export * from './controllers/hooksServices/AttachmentHooksService';
export * from './controllers/hooksServices/NotesHookService';
export * from './controllers/hooksServices/AxiosHooksService';
export * from './controllers/hooksServices/prismInvestmentApi';
export * from './controllers/AIMController'
export * from './controllers/hooksServices/prismInvestmentApi';
export { isDevEnv, prismFunctionCode } from './controllers/utils/getBaseUrl';
